import React, { Children, FC, PropsWithChildren } from "react";
import { Route, Routes } from "react-router-dom";
import { ContainerBlock } from "./ContainerStyles";

const Container: FC<PropsWithChildren> = ({ children }) => {
  return <ContainerBlock>{children}</ContainerBlock>;
};

export default Container;
